<template>
    <v-checkbox
        v-model="showConvertPrices"
        hide-details
        class="mt-0 pt-0"
        data-cy="cancelled-services-checkbox"
        @update:model-value="persistentStore.showConvertPrices = showConvertPrices"
    >
        <template v-slot:label>
            <span class="text-body-2">
                {{ $t('convert_prices') }}
            </span>
        </template>
    </v-checkbox>
</template>

<script setup lang="ts">
    const showConvertPrices = ref<boolean>(persistentStore.showConvertPrices)
</script>
